var render = function render(){var _vm=this,_c=_vm._self._c;return _c('base-link',_vm._g(_vm._b({staticClass:"link--icon"},'base-link',_vm.$attrs,false),_vm.$listeners),[_vm._t("default"),(_vm.icon)?_c('svg',{directives:[{name:"svg",rawName:"v-svg"}],staticClass:"icon",attrs:{"symbol":_vm.icon,"size":_vm.size,"role":"presentation"}}):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }